import { render, staticRenderFns } from "./InvalidURL.vue?vue&type=template&id=127fc2dc&scoped=true"
var script = {}
import style0 from "./InvalidURL.vue?vue&type=style&index=0&id=127fc2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127fc2dc",
  null
  
)

export default component.exports